import Collapse from "@material-ui/core/Collapse";
import Icon from "@material-ui/core/Icon";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import PropTypes from "prop-types";
import React from "react";
import { withRouter } from "react-router";

import { globalHistory } from "../history";

class KnowledgeBaseItem extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.history = globalHistory();
  }
  state = {
    selectedIndex: 0,
    open: false,
  };

  handleListItemClick = (event, index) => {
    this.setState({ selectedIndex: index });
  };

  handleClick = () => {
    this.setState((state) => ({ open: !state.open }));
  };

  handleClickTopic = () => {
    this.setState((state) => ({ openTopic: !state.openTopic }));
  };

  render() {
    const pathname = this.props.location.pathname;
    const { title, subItems } = this.props;
    return (
      <React.Fragment key={this.props.key}>
        <ListItem button onClick={this.handleClick}>
          <ListItemIcon>
            <Icon>{this.props.iconString}</Icon>
          </ListItemIcon>
          <ListItemText primary={title} style={{ whiteSpace: "nowrap" }} />
          {this.state.open ? (
            <ExpandLess style={{ color: "#fff" }} />
          ) : (
            <ExpandMore style={{ color: "#fff" }} />
          )}
        </ListItem>
        <Collapse in={this.state.open} timeout="auto">
          {subItems.map((item) => {
            return (
              <div style={{ marginLeft: 25 }}>
                <ListItem button onClick={this.handleClickTopic}>
                  <ListItemIcon>
                    <Icon>{item.icon}</Icon>
                  </ListItemIcon>
                  <ListItemText
                    primary={item.title}
                    style={{ whiteSpace: "nowrap" }}
                  />
                  {this.state.openTopic ? (
                    <ExpandLess style={{ color: "#fff" }} />
                  ) : (
                    <ExpandMore style={{ color: "#fff" }} />
                  )}
                </ListItem>
                <Collapse in={this.state.openTopic} timeout="auto">
                  {item.articles.map((article) => {
                    return (
                      <div style={{ marginLeft: 25 }}>
                        <ListItem
                          disableTouchRipple
                          button
                          onClick={() =>
                            this.props.handleOpenArticle(article.id)
                          }>
                          <ListItemIcon>
                            <Icon>{article.icon}</Icon>
                          </ListItemIcon>
                          <ListItemText
                            style={{ whiteSpace: "nowrap" }}
                            primary={article.title}
                          />
                        </ListItem>
                      </div>
                    );
                  })}
                </Collapse>
              </div>
            );
          })}
        </Collapse>
      </React.Fragment>
    );
  }
}

KnowledgeBaseItem.propTypes = {
  title: PropTypes.string,
  subItems: PropTypes.array,
  iconString: PropTypes.string,
  handleOpenArticle: PropTypes.func,
};

export default withRouter(KnowledgeBaseItem);
